import { Suspense } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ScreenDef } from '@/lib/types';
import type { Tab } from '@/shell/workspace';
import { Spinner, ErrorBox } from '@/ui/Spinner';
import { DizaynScreen } from './DizaynScreen';
import { DizaynBelgeScreen } from './DizaynBelgeScreen';
import { TableScreen } from './TableScreen';
import { ExternalScreen } from './ExternalScreen';
import { customScreens } from './custom/registry';
import { Sms } from './custom/Sms';
import { ReportGroupScreen } from '@/reports/ReportGroupScreen';
import { ReportRunner } from '@/reports/ReportRunner';

/** Sekme içeriği: ekran tanımını (Web_Screen) getirip türüne göre dinamik bileşeni seçer */
export function ScreenHost({ tab }: { tab: Tab }) {
  if (tab.kind === 'report-group') return <ReportGroupScreen group={tab.reportGroup!} />;
  if (tab.kind === 'report') return <ReportRunner reportId={tab.reportId!} initial={tab.props?.params} />;
  if (tab.kind === 'custom') {
    const C = customScreens[tab.component ?? ''];
    return C ? <Suspense fallback={<Spinner />}><C screen={tab.props?.screen} {...(tab.props ?? {})} /></Suspense> : <ErrorBox error={`Bileşen bulunamadı: ${tab.component}`} />;
  }
  return <TagScreen tag={tab.tag!} />;
}

function TagScreen({ tag }: { tag: number }) {
  const q = useQuery({ queryKey: ['screen', tag], queryFn: () => api<ScreenDef>(`/screens/${tag}`) });
  if (q.isLoading) return <Spinner />;
  if (q.error) return <ErrorBox error={q.error} />;
  const s = q.data!;
  switch (s.kind) {
    case 'dizayn': return s.settings?.sms ? <Sms screen={s} /> : <DizaynScreen screen={s} />;
    case 'dizayn-belge': return <DizaynBelgeScreen screen={s} />;
    case 'tablo': return <TableScreen screen={s} />;
    case 'harici': return <ExternalScreen screen={s} />;
    case 'ozel': {
      const C = customScreens[s.settings?.bilesen];
      return C ? <Suspense fallback={<Spinner />}><C screen={s} /></Suspense> : <ExternalScreen screen={s} notImplemented />;
    }
    default: return <ErrorBox error={`Desteklenmeyen ekran türü: ${s.kind}`} />;
  }
}
